import Typography from 'typography'
import theme from 'typography-theme-lincoln'

theme.overrideThemeStyles = () => ({
  a: {
    backgroundImage: 'none',
    textDecoration: 'underline',
    textShadow: 'none',
  },
  'a:hover,a:active': {
    textDecoration: 'none',
  },
})

const typography = new Typography(theme)

export default typography



// WEBPACK FOOTER //
// ./src/utils/typography.js